import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import ImgPopup from '../images/popup.jpg'
import { MdPerson, MdEmail, MdPhone, MdCampaign } from 'react-icons/md';
import { Button, Modal, Tabs, Input } from 'antd';
import GooeyNav from './GooeyNav';
import Img1 from '../images/logo.png'
import { IoMdCart } from "react-icons/io";
import { ArrowRightOutlined, EyeInvisibleOutlined, EyeOutlined, UserOutlined } from "@ant-design/icons";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';
import { useSettings } from '../context/settingContext';
import SearchBar from './SearchBar';


function Header() {
  const { settings, user, Logout } = useSettings();
  const [modal2Open, setModal2Open] = useState(false);


  const items = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Shop', href: '/shop' },
    { label: 'Contact ', href: '/contact' }
  ]

  const { TabPane } = Tabs;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);

  const [registerData, setRegisterData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e, setter) => {
    const { name, value } = e.target;
    setter((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLogin, setIsLogin] = useState(false);

  const registerSubmit = async (e) => {
    e.preventDefault();
    const { firstname, lastname, email, password, password_confirmation } = registerData;

    if (!firstname || !lastname || !email || !password || !password_confirmation) {
      toast.error("All fields are required");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Invalid email format");
      return;
    }

    const passwordRegex = /^(?=.*[0-9])[A-Z][a-zA-Z0-9]{7,}$/;
    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters, start with a capital letter, and include a number");
      return;
    }

    if (password !== password_confirmation) {
      toast.error("Passwords do not match");
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/register-user`, registerData, {
        headers: {
          "Content-Type": "application/json"
        },
      });

      if (res.data.data.message === "Success") {
        toast.success('Registration successful!');
        secureLocalStorage.setItem('user', JSON.stringify(res.data.data.attributes));
        setTimeout(() => {
          window.location.replace('/dashboard/');
        }, 1000);
      } else {
        toast.error(res.data.data.message || 'Registration failed.');
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const loginSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = loginData;
    if (!email || !password) {
      toast.error("All fields are required");
      return;
    }
    setIsLogin(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}api/user-login`, loginData,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      )
      if (res.status === 200 && res.data.status === true) {
        toast.success(res?.data?.message);
        secureLocalStorage.setItem('user', JSON.stringify(res.data.data));
        setTimeout(() => {
          window.location.replace('/dashboard/')
        }, 1000);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setIsLogin(false);
    }
  }

  const getUser = user;
  const [open, setOpen] = useState(false);

  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const calculateCartCount = () => {
      let total = 0;
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        try {
          const item = JSON.parse(localStorage.getItem(key));
          if (item && item.quantity) total += item.quantity;
        } catch (err) {
          console.log("cart count error", err);
        }
      }
      setCartCount(total);
    };
    calculateCartCount();
    window.addEventListener("storage", calculateCartCount);
    window.addEventListener("cartUpdated", calculateCartCount);
    return () => {
      window.removeEventListener("storage", calculateCartCount);
      window.removeEventListener("cartUpdated", calculateCartCount);
    };
  }, []);

  return (
    <header className="bg-[#000] shadow-md rounded-bl-[2vw] rounded-br-[2vw]">
      <div className="container mx-auto px-4">
        <nav className=" header-motion flex flex-col md:flex-row justify-between items-center space-y-5 md:space-y-0 md:space-x-8 py-4 2xl:max-w-[1536px] 2xl:mx-auto ">
          <Link
            to={`mailto:${settings?.email}`}
            className="font-outfit flex items-center text-white hover:text-brandBlue transition-colors duration-200">
            <MdEmail className="mr-2 text-lg" />
            {settings?.email}
          </Link>

          <Link
            to="/shop"
            className="font-outfit flex items-center text-white hover:text-brandBlue transition-colors duration-200">
            <MdCampaign className="mr-2 text-lg" />
            Flash Sale Alert: Save Up to 40% - Limited Stock
          </Link>

          <Link
            to={`tel:${settings?.phone}`}
            className="font-outfit flex items-center text-white hover:text-brandBlue transition-colors duration-200">
            <MdPhone className="mr-2 text-lg" />
            {settings?.phone}
          </Link>
        </nav>
      </div>
      <div className="container mx-auto px-4">
        <nav className='absolute flex justify-between items-center py-4 pt-[30px] w-full max-w-[95rem] mx-auto gap-[115px]'>
          <div className="logo">
            <Link to="/">  <img src={settings.logo || Img1} className='w-[100%] h-[100px] object-cover' alt="" /></Link>
          </div>
          <ul className='header flex justify-between gap-[1vw] items-center py-5 pl-[30px] font-outfit'>
            <GooeyNav
              className="gooey-nav font-outfit"
              items={items}
              particleCount={15}
              particleDistances={[90, 10]}
              particleR={300}
              initialActiveIndex={0}
              animationTime={600}
              timeVariance={300}
              colors={[1, 2, 3, 1, 2, 3, 1, 4]}
            />

          </ul>
          <ul className='flex justify-between gap-[15px] items-center py-5 pr-[30px] font-outfit pl-[50px]'>
            <SearchBar />
            {
              getUser === null ? (
                <li>
                  <Button type="primary" onClick={() => setModal2Open(true)} className='bg-black hover:bg-brandBlue'>
                    <MdPerson />
                  </Button>
                  <Modal
                    title={null}
                    centered
                    open={modal2Open}
                    onOk={() => setModal2Open(false)}
                    onCancel={() => setModal2Open(false)}
                    width={900}
                    footer={null}
                  >
                    <Row gutter={0} className="bg-white overflow-hidden">
                      <Col span={12}>
                        <div className="main-popup-pic w-full h-full">
                          <img
                            src={ImgPopup}
                            alt="img"
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </Col>
                      <Col span={12} className="p-8 flex flex-col justify-center">
                        <Tabs defaultActiveKey="1" centered>
                          <TabPane tab="Sign Up" key="1">
                            <h2 className="text-2xl font-bold text-blue-700 mb-2 font-syne">
                              Create Your Account
                            </h2>
                            <p className="text-gray-600 mb-6 font-outfit">
                              Unlock exclusive offers, early access to new launches, and
                              personalized recommendations.
                            </p>
                            <form className="space-y-4" onSubmit={registerSubmit}>
                              <Row gutter={10}>
                                <Col span={12}>
                                  <input
                                    type="text"
                                    name="firstname"
                                    placeholder="Enter Your First Name ..."
                                    className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit"
                                    onChange={(e) => handleChange(e, setRegisterData)}
                                    value={registerData.firstname}
                                  />
                                </Col>
                                <Col span={12}>
                                  <input
                                    type="text"
                                    name="lastname"
                                    placeholder="Enter Your Last Name ..."
                                    className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit"
                                    onChange={(e) => handleChange(e, setRegisterData)}
                                    value={registerData.lastname}
                                  />
                                </Col>
                              </Row>
                              <input
                                type="email"
                                name="email"
                                placeholder="Enter Your Email Address ..."
                                className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit"
                                onChange={(e) => handleChange(e, setRegisterData)}
                                value={registerData.email}
                              />
                              <div className="relative">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  placeholder="Enter Your Password ..."
                                  className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit pr-10"
                                  onChange={(e) => handleChange(e, setRegisterData)}
                                  value={registerData.password}
                                />
                                <span
                                  className="absolute right-4 top-3 cursor-pointer text-gray-500"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                </span>
                              </div>
                              <div className="relative">
                                <input
                                  type={showConfirmPassword ? "text" : "password"}
                                  name="password_confirmation"
                                  placeholder="Confirm Your Password ..."
                                  className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit pr-10"
                                  onChange={(e) => handleChange(e, setRegisterData)}
                                  value={registerData.password_confirmation}
                                />
                                <span
                                  className="absolute right-4 top-3 cursor-pointer text-gray-500"
                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                  {showConfirmPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                </span>
                              </div>
                              <p className="text-xs text-gray-500 mt-2">
                                By signing up, you agree to our{" "}
                                <Link to="/terms-conditions" className="underline font-outfit" onClick={() => setModal2Open(false)}>
                                  Terms & Conditions
                                </Link>{" "}
                                and{" "}
                                <Link to="/privacy-policy" className="underline font-outfit" onClick={() => setModal2Open(false)}>
                                  Privacy Policy
                                </Link>
                                .
                              </p>
                              <button
                                type="submit"
                                className="w-full bg-blue-600 text-white py-3 rounded-full flex items-center justify-center gap-2 hover:bg-blue-700 transition font-outfit"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Signing up..." : "Sign up"} <ArrowRightOutlined />
                              </button>
                            </form>
                          </TabPane>
                          <TabPane tab="Login" key="2">
                            <h2 className="text-2xl font-bold text-blue-700 mb-2 font-syne">
                              Welcome Back
                            </h2>
                            <p className="text-gray-600 mb-6 font-outfit">
                              Log in to access your account and continue your journey.
                            </p>
                            <form className="space-y-4" onSubmit={loginSubmit}>
                              <input
                                type="email"
                                name="email"
                                placeholder="Enter Your Email Address ..."
                                className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit"
                                onChange={(e) => handleChange(e, setLoginData)}
                                value={loginData.email}
                              />
                              <div className="relative">
                                <input
                                  type={showLoginPassword ? "text" : "password"}
                                  name="password"
                                  placeholder="Enter Your Password ..."
                                  className="w-full p-3 border border-gray-300 rounded-full focus:outline-none font-outfit pr-10"
                                  onChange={(e) => handleChange(e, setLoginData)}
                                  value={loginData.password}
                                />
                                <span
                                  className="absolute right-4 top-3 cursor-pointer text-gray-500"
                                  onClick={() => setShowLoginPassword(!showLoginPassword)}
                                >
                                  {showLoginPassword ? (
                                    <EyeInvisibleOutlined />
                                  ) : (
                                    <EyeOutlined />
                                  )}
                                </span>
                              </div>

                              <div className="flex justify-between items-center text-sm text-gray-600">
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" /> Remember Me
                                </label>
                                <Link to="/forgot-password" className="underline font-outfit" onClick={() => setModal2Open(false)}>
                                  Forgot Password?
                                </Link>
                              </div>

                              <button
                                type="submit"
                                className="w-full bg-blue-600 text-white py-3 rounded-full flex items-center justify-center gap-2 hover:bg-blue-700 transition font-outfit"
                                disabled={isLogin}
                              >
                                {isLogin ? 'Logging in...' : 'Login'} <ArrowRightOutlined />
                              </button>
                            </form>
                          </TabPane>
                        </Tabs>
                      </Col>
                    </Row>
                  </Modal>
                </li>
              ) : (
                <li>
                  <div className="relative inline-block text-left">
                    <button
                      onClick={() => setOpen(!open)}
                      className="flex items-center gap-2 bg-white px-1.5 py-1.5 rounded-full shadow hover:bg-gray-100 transition"
                    >
                      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-brandBlue text-white font-bold">
                        {
                          getUser.photo === "https://fragrances.demo-customproject.com/backend/" || !getUser.photo
                            ? <UserOutlined />
                            : <img
                              src={getUser.photo}
                              alt="img"
                              className="rounded-[50px] d-block w-[30px] h-[30px] object-cover"
                            />
                        }
                      </div>
                      <span className="hidden md:block font-medium text-gray-700">
                        {getUser.fname} {getUser.lname}
                      </span>
                      <svg
                        className={`w-4 h-4 text-gray-500 transform transition ${open ? "rotate-180" : "rotate-0"
                          }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {open && (
                      <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                        <ul className="py-1">
                          <li>
                            <Link to="/dashboard" className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left' onClick={() => setOpen(false)}>My Account</Link>
                            <button
                              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                              onClick={Logout}
                            >
                              Logout
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </li>
              )
            }
            <li>
              <Link to="/cart" className='text-black-600 text-2xl font-bold hover:text-brandBlue transition-colors duration-300 text-black relative'>< IoMdCart />
                {cartCount > 0 && (
                  <span className="cart_countt">{cartCount}</span>
                )}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
